<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar
              btn
              icon="mdi-database"
              path="/homeMenuAdminArchive"
            >
              {{ $t("dashboardCardModulePhotoOrderTitle") }}
              <v-avatar
                color="error"
                size="28"
                class="ml-1"
                v-if="
                  $store.state.storeOrders.packages.filter((x) => x.status == 0)
                    .length > 0
                "
              >
                <span class="white--text subtitle-2">
                  {{
                    $store.state.storeOrders.packages.filter(
                      (x) => x.status == 0
                    ).length
                  }}
                </span>
              </v-avatar>
              <v-avatar
                color="warning"
                size="28"
                class="ml-1"
                v-if="
                  $store.state.storeOrders.packages.filter((x) => x.status == 1)
                    .length > 0
                "
              >
                <span class="white--text subtitle-2">
                  {{
                    $store.state.storeOrders.packages.filter(
                      (x) => x.status == 1
                    ).length
                  }}
                </span>
              </v-avatar>
              <v-avatar
                color="success"
                size="28"
                class="ml-1"
                v-if="
                  $store.state.storeOrders.packages.filter((x) => x.status == 2)
                    .length > 0
                "
              >
                <span class="white--text subtitle-2">
                  {{
                    $store.state.storeOrders.packages.filter(
                      (x) => x.status == 2
                    ).length
                  }}
                </span>
              </v-avatar>
            </main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-6 pa-0 pb-10">
            <v-card
              class="#505050--text"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray; background-color: whitesmoke'
                  : 'border: none; background-color: white'
              "
            >
              <transition name="fade" key="2" mode="out-in">
                <v-card-text
                  class="ma-0 pa-0"
                  key="2"
                  v-show="visibleIsAdminShowPackages"
                >
                  <div
                    class="
                      font-weight-regular
                      px-4
                      py-2
                      ma-0
                      white--text
                      warning
                    "
                    v-if="
                      $store.state.storeClient.client.modules.modulePhotoOrder
                        .active && $store.state.storeAuth.userProfile.isAdmin
                    "
                  >
                    <div class="animated bounceInRight">
                      <span
                        class="ma-0 pa-0"
                        v-if="
                          $store.state.storeAuth.userProfile.isAdminShowPackages
                            .length > 0
                        "
                      >
                        <v-icon color="white" left medium>mdi-eye</v-icon>
                        <span
                          v-for="(item, index) in $store.state.storeAuth
                            .userProfile.isAdminShowPackages"
                          :key="item"
                          class="ml-1"
                        >
                          <span v-if="index > 0">
                            <v-icon color="white" left small
                              >mdi-circle-small</v-icon
                            >
                          </span>
                          {{ item }}
                        </span>
                      </span>
                      <span v-else>
                        <v-icon color="white" left medium>mdi-eye</v-icon>
                        {{ $t("dashboardCardAdminActivePackagesViewTitle") }}
                      </span>
                    </div>
                  </div>
                </v-card-text>
              </transition>

              <v-card-text
                v-if="selection.some((el) => !!el)"
                class="pa-0 ma-0 px-2"
              >
                <v-btn
                  color="primary"
                  outlined
                  class="mx-0 mr-2 mt-2"
                  @click="selectAll"
                  >{{ $t("msgSelectAll") }}</v-btn
                >
                <v-btn
                  color="primary"
                  outlined
                  class="mx-0 mr-2 mt-2"
                  @click="selectDoneOlder"
                  >{{ $t("msgSelectDoneOlder") }}</v-btn
                >
                <v-btn
                  color="primary"
                  outlined
                  class="mx-0 mr-2 mt-2"
                  @click="selection = []"
                  >{{ $t("msgDeselectAll") }}</v-btn
                >
                <v-btn
                  color="green"
                  class="mx-0 mr-2 elevation-0 mt-2 white--text"
                  @click="
                    dialog = true;
                    multipleDone = true;
                  "
                  >{{ $t("homeMenuAdminPackagesBtnDoneSelection") }} ({{
                    numOfSelectedItems
                  }})</v-btn
                >
                <v-btn
                  color="black"
                  class="mx-0 mr-2 elevation-0 mt-2 white--text"
                  @click="
                    dialog2 = true;
                    multipleDelivered = true;
                  "
                  >{{ $t("homeMenuAdminPackagesBtnDeliveredSelection") }} ({{
                    numOfSelectedItems
                  }})</v-btn
                >
              </v-card-text>

              <v-card-text
                v-if="$store.state.storeOrders.packages.length > 0"
                class="my-0 pa-2 py-2"
              >
                <div
                  style="background-color: #fcfcfc; border: 1px solid gainsboro"
                  class="ma-0"
                >
                  <v-expansion-panels accordion>
                    <div
                      class="my-2"
                      v-if="$store.state.storeOrders.packages.length == 0"
                    >
                      <strong>{{ $t("homeMenuAdminPackagesEmptyMsg") }}</strong>
                    </div>
                    <v-expansion-panel
                      v-else
                      v-for="(item, index) in $store.state.storeOrders.packages"
                      :key="item.id"
                    >
                      <v-expansion-panel-header
                        class="pa-3 py-1"
                        :style="getStatusColor(item.status, true)"
                      >
                        <!-- EXPORT PDF HIDDEN CONTENT -->
                        <div v-show="false">
                          <div :id="'exportPdf-' + item.orderId">
                            <export-order-info :item="item"></export-order-info>
                          </div>
                        </div>

                        <div id="cesplja">
                          <!-- internal notes show -->
                          <div
                            v-if="
                              item.internalNotes !== undefined &&
                              item.status <= 1
                            "
                            class="d-flex align-center flex-wrap pa-0 ma-0 mt-1"
                          >
                            <span
                              class="pa-1 mr-1 mb-1"
                              style="background-color: yellow"
                              v-for="(item2, index2) in item.internalNotes"
                              :key="index2"
                              >{{ item2.fullName }}: {{ item2.msg }}
                              <v-icon
                                v-if="
                                  item2.email ==
                                  $store.state.storeAuth.userProfile.email
                                "
                                x-small
                                @click="
                                  currentItem = item;
                                  currentIndex = index2;
                                  dialogDeleteInternalNote = true;
                                "
                                >mdi-close</v-icon
                              >
                            </span>
                          </div>

                          <div
                            class="
                              d-flex
                              align-center
                              justify-middle
                              flex-wrap
                              pa-0
                              ma-0
                            "
                          >
                            <!-- check box selection -->
                            <v-checkbox
                              class="ma-0 pa-0"
                              style="height: 24px"
                              :value="item.id"
                              :key="index"
                              v-model="selection"
                              @click.stop
                            >
                            </v-checkbox>

                            <!-- print order button -->
                            <v-icon
                              medium
                              @click="printJSPage(item.orderId)"
                              @click.stop
                              class="secondary--text hover-item mr-2"
                              >mdi-printer</v-icon
                            >

                            <!-- export pdf button -->
                            <v-icon
                              medium
                              @click="exportOrderToPdf(item.orderId)"
                              @click.stop
                              class="secondary--text hover-item mr-2"
                              >mdi-file-export</v-icon
                            >

                            <!-- internal note button -->
                            <v-icon
                              medium
                              @click.stop
                              @click="
                                currentItem = item;
                                dialogAddInternalNote = true;
                              "
                              class="secondary--text hover-item mr-2"
                              >mdi-bell-plus-outline</v-icon
                            >

                            <v-btn-toggle
                              mandatory
                              dense
                              class="pa-0 ma-0 my-2 mr-2"
                              :style="getStatusColor(item.status, true)"
                              :value="String(item.status)"
                            >
                              <v-btn
                                value="0"
                                min-width="40"
                                @click.stop
                                @click="setPackageStatus(item.id, 0, 0)"
                              >
                                <v-icon color="error" small
                                  >mdi-circle-slice-8</v-icon
                                >
                                <span class="hidden-xs-only pl-1">{{
                                  $t("userOrdersStatus0Title")
                                }}</span>
                              </v-btn>
                              <v-btn
                                value="1"
                                min-width="40"
                                @click.stop
                                @click="setPackageStatus(item.id, 1, 0)"
                              >
                                <v-icon color="warning" small
                                  >mdi-circle-slice-8</v-icon
                                >
                                <span class="hidden-xs-only pl-1">{{
                                  $t("userOrdersStatus1Title")
                                }}</span>
                              </v-btn>

                              <!-- Pošlji sporočilo stranki ob narejenem naročilu dialog -->
                              <v-dialog
                                v-model="dialog"
                                persistent
                                transition="dialog-bottom-transition"
                                style="z-index: 2000"
                                max-width="400"
                                :retain-focus="false"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    value="2"
                                    min-width="40"
                                    @click.stop
                                    @click="currentItem = item"
                                    v-on="on"
                                  >
                                    <v-icon color="success" small
                                      >mdi-circle-slice-8</v-icon
                                    >
                                    <span class="hidden-xs-only pl-1">{{
                                      $t("userOrdersStatus2Title")
                                    }}</span>
                                    <v-icon class="ml-2" small color="primary"
                                      >mdi-email-plus-outline</v-icon
                                    >
                                  </v-btn>
                                </template>
                                <v-card
                                  class="text-center"
                                  :class="
                                    getTheme() == 'dark'
                                      ? 'outlined elevation-0'
                                      : 'flat elevation-0'
                                  "
                                  :style="
                                    getTheme() == 'dark'
                                      ? ''
                                      : 'border-bottom: 1px solid lightgray'
                                  "
                                >
                                  <v-card-title
                                    :style="
                                      getTheme() == 'dark'
                                        ? 'background-color: #505050'
                                        : 'background-color: white; border-bottom: 1px solid lightgray'
                                    "
                                    :class="
                                      getTheme() == 'dark'
                                        ? 'white--text'
                                        : '#505050--text'
                                    "
                                    class="title font-weight-regular"
                                  >
                                    <v-icon
                                      :class="
                                        getTheme() == 'dark'
                                          ? 'white--text'
                                          : 'primary--text'
                                      "
                                      class="mr-3"
                                      medium
                                      >mdi-comment-question-outline</v-icon
                                    >
                                    {{ $t("msgConfirm") }}
                                  </v-card-title>
                                  <v-card-text class="pt-6 pb-6">
                                    <div class="pb-2">
                                      {{
                                        $t(
                                          "homeMenuAdminPackagesNotificationQuestionWarningTitle"
                                        )
                                      }}
                                    </div>
                                    <div>
                                      {{
                                        $t(
                                          "homeMenuAdminPackagesNotificationQuestionTitle"
                                        )
                                      }}
                                    </div>
                                    <div v-if="multipleDone">
                                      <strong>{{
                                        $t(
                                          "homeMenuAdminPackagesMultipleRecipients"
                                        )
                                      }}</strong>
                                    </div>
                                    <div v-else>
                                      <strong>
                                        {{
                                          currentItem.fullName +
                                          " (" +
                                          currentItem.email +
                                          ")"
                                        }}
                                      </strong>
                                    </div>
                                  </v-card-text>
                                  <v-card-actions
                                    :class="
                                      getTheme() == 'dark'
                                        ? '#505050--text'
                                        : '#505050--text'
                                    "
                                    :style="
                                      getTheme() == 'dark'
                                        ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                                        : 'background-color: white; border-top: 1px solid lightgray;'
                                    "
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="primary"
                                      text
                                      class="mx-0"
                                      @click="
                                        dialog = false;
                                        multipleDone = false;
                                      "
                                      >{{
                                        $t("addEditFormCancelButton")
                                      }}</v-btn
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="primary"
                                      text
                                      class="mx-0"
                                      @click="checkMultipleDone(0)"
                                      >{{ $t("lmBtnNo") }}</v-btn
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="primary"
                                      text
                                      class="mx-0"
                                      @click="checkMultipleDone(1)"
                                      >{{ $t("lmBtnYes") }}</v-btn
                                    >
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>

                              <!-- Izbriši iz storagea vse pakete tega naročila dialog -->
                              <v-dialog
                                v-model="dialog2"
                                persistent
                                transition="dialog-bottom-transition"
                                style="z-index: 2000"
                                max-width="400"
                                :retain-focus="false"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    value="3"
                                    min-width="40"
                                    v-on="on"
                                    @click.stop
                                    @click="currentItem = item"
                                  >
                                    <v-icon small>mdi-circle-slice-8</v-icon>
                                    <span class="hidden-xs-only pl-1">
                                      {{
                                        item.deliveryShowAddress
                                          ? $t("userOrdersStatus3bTitle")
                                          : $t("userOrdersStatus3aTitle")
                                      }}
                                    </span>
                                    <v-icon small class="ml-2" color="primary"
                                      >mdi-database-minus</v-icon
                                    >
                                  </v-btn>
                                </template>
                                <v-card
                                  class="text-center"
                                  :class="
                                    getTheme() == 'dark'
                                      ? 'outlined elevation-0'
                                      : 'flat elevation-0'
                                  "
                                  :style="
                                    getTheme() == 'dark'
                                      ? ''
                                      : 'border-bottom: 1px solid lightgray'
                                  "
                                >
                                  <v-card-title
                                    :style="
                                      getTheme() == 'dark'
                                        ? 'background-color: #505050'
                                        : 'background-color: white; border-bottom: 1px solid lightgray'
                                    "
                                    :class="
                                      getTheme() == 'dark'
                                        ? 'white--text'
                                        : '#505050--text'
                                    "
                                    class="title font-weight-regular"
                                  >
                                    <v-icon
                                      :class="
                                        getTheme() == 'dark'
                                          ? 'white--text'
                                          : 'primary--text'
                                      "
                                      class="mr-3"
                                      medium
                                      >mdi-comment-question-outline</v-icon
                                    >
                                    {{ $t("msgConfirm") }}
                                  </v-card-title>
                                  <v-card-text class="pt-6 pb-6">{{
                                    $t(
                                      "homeMenuAdminPackagesDeleteFromStorageTitle"
                                    )
                                  }}</v-card-text>
                                  <v-card-actions
                                    :class="
                                      getTheme() == 'dark'
                                        ? '#505050--text'
                                        : '#505050--text'
                                    "
                                    :style="
                                      getTheme() == 'dark'
                                        ? 'background-color: whitesmoke; border-top: 1px solid lightgray;'
                                        : 'background-color: white; border-top: 1px solid lightgray;'
                                    "
                                  >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="primary"
                                      text
                                      class="mx-0"
                                      @click="
                                        dialog2 = false;
                                        multipleDelivered = false;
                                      "
                                      >{{ $t("lmBtnBack") }}</v-btn
                                    >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="primary"
                                      text
                                      class="mx-0"
                                      @click="checkMultipleDelivered"
                                      >{{ $t("lmBtnConfirm") }}</v-btn
                                    >
                                    <v-spacer></v-spacer>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-btn-toggle>

                            <div
                              class="
                                d-flex
                                align-center
                                flex-wrap
                                pa-0
                                ma-0
                                mt-1
                              "
                              v-if="item.messageForStudio.length > 0"
                            >
                              <v-icon medium color="red" class="mr-2"
                                >mdi-message-reply-text</v-icon
                              >
                            </div>

                            <div
                              class="
                                d-flex
                                align-center
                                flex-wrap
                                pa-0
                                ma-0
                                mt-1
                              "
                            >
                              <div
                                v-for="(item2, index2) in item.storeCart.cart"
                                :key="index2"
                              >
                                <v-icon
                                  v-if="item2.module == G_MODULE_PHOTO_ORDER"
                                  small
                                  :color="
                                    item2.done || item.status > 1
                                      ? 'success'
                                      : 'gray'
                                  "
                                  class="mr-1 mb-1"
                                  >mdi-image-multiple</v-icon
                                >
                                <span
                                  v-else-if="
                                    item2.module == G_MODULE_PHOTO_GIFT
                                  "
                                >
                                  <span v-if="item2.superType !== undefined">
                                    <v-icon
                                      v-if="item2.superType == 0"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-package-variant</v-icon
                                    >
                                    <v-icon
                                      v-else-if="item2.superType == 1"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-glass-mug</v-icon
                                    >
                                    <v-icon
                                      v-else-if="item2.superType == 2"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-collage</v-icon
                                    >
                                    <v-icon
                                      v-else-if="item2.superType == 3"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-picture-in-picture-bottom-right</v-icon
                                    >
                                    <v-icon
                                      v-else-if="item2.superType == 4"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-wallet-giftcard</v-icon
                                    >
                                    <v-icon
                                      v-else-if="item2.superType == 5"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-resize</v-icon
                                    >
                                    <v-icon
                                      v-else-if="item2.superType == 6"
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-palette</v-icon
                                    >
                                  </span>
                                  <span v-else>
                                    <v-icon
                                      small
                                      :color="
                                        item2.done || item.status > 1
                                          ? 'success'
                                          : 'gray'
                                      "
                                      class="mr-1 mb-1"
                                      >mdi-glass-mug</v-icon
                                    >
                                  </span>
                                </span>
                              </div>
                            </div>
                          </div>

                          <div
                            class="d-flex align-center flex-wrap pa-0 ma-0 mt-1"
                          >
                            <div class="mb-1 mr-2" v-if="item.orders == 1">
                              <v-icon medium color="primary"
                                >mdi-new-box</v-icon
                              >
                            </div>
                            <div
                              class="mb-1 mr-2"
                              v-else-if="item.orders > 1 && item.orders < 10"
                            >
                              <v-icon small color="primary"
                                >mdi-numeric-{{
                                  item.orders
                                }}-box-multiple-outline</v-icon
                              >
                            </div>
                            <div class="mb-1 mr-2" v-else-if="item.orders > 9">
                              <v-icon small color="primary"
                                >mdi-numeric-9-plus-box-multiple-outline</v-icon
                              >
                            </div>
                            <div class="mb-1 mr-2">
                              <strong>{{ item.orderId }}</strong>
                              ({{ item.fullName }})
                            </div>
                            <div class="mb-1 mr-2">
                              <v-icon small color="primary" class="mr-1 mb-1"
                                >mdi-alarm-plus</v-icon
                              >
                              {{ $t("msgAddedTitle") }}
                              {{ timePassedSinceAdd(item.timestamp.seconds) }}
                            </div>
                            <div class="mb-1 mr-2">
                              <v-icon small color="primary" class="mr-1 mb-1"
                                >mdi-walk</v-icon
                              >
                              {{ item.deliveryName }}
                            </div>
                            <div
                              v-if="item.deliveryType == 'prepay'"
                              class="mb-1 mr-2 pa-1 pb-0"
                              style="background-color: red; color: white"
                            >
                              <v-icon small color="white" class="mr-1 mb-1"
                                >mdi-account-cash</v-icon
                              >
                              {{ item.deliveryTypeString }}
                            </div>
                            <div v-else class="mb-1 mr-2">
                              <v-icon small color="primary" class="mr-1 mb-1"
                                >mdi-account-cash</v-icon
                              >
                              {{ item.deliveryTypeString }}
                            </div>
                            <div class="mr-2">
                              <v-icon small color="primary" class="mr-2 mb-1"
                                >mdi-cash-multiple</v-icon
                              >
                              <strong>{{
                                price(item.deliveryFinalSum)
                              }}</strong>
                            </div>
                          </div>
                        </div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="pa-0 pb-4 ma-0">
                        <display-order-info
                          mode="packages"
                          :item="item"
                          :stats="true"
                        ></display-order-info>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </div>
              </v-card-text>
              <v-card-text v-else class="d-flex ma-0 py-5">
                <v-spacer></v-spacer>
                <div>
                  <v-icon small>mdi-emoticon-happy-outline</v-icon>
                  <span class="ml-2 subtitle-2">
                    {{ $t("homeMenuAdminPackagesEmptyMsg") }}
                  </span>
                </div>
                <v-spacer></v-spacer>
              </v-card-text>
            </v-card>
          </v-flex>

          <!-- confirm internal note delete dialog -->
          <dialog-basic-yes-no
            :active="dialogDeleteInternalNote"
            @clickYes="deleteInternalNote"
            @clickNo="dialogDeleteInternalNote = false"
            icon="mdi-delete"
            :title="$t('homeMenuAdminPackagesInternalNoteDeleteTitle')"
            >{{
              $t("homeMenuAdminPackagesInternalNoteDeleteBodyTitle")
            }}</dialog-basic-yes-no
          >

          <!-- add internal note dialog -->
          <dialog-send-msg
            :active="dialogAddInternalNote"
            @clickAdd="addInternalNote"
            @clickCancel="dialogAddInternalNote = false"
            icon="mdi-bell-plus-outline"
            addBtnIcon="mdi-bell-plus-outline"
            :addBtnText="$t('lmBtnAdd')"
            :title="$t('homeMenuAdminPackagesInternalNoteTitle')"
            >{{ currentItem.orderId }} /
            {{ currentItem.fullName }}</dialog-send-msg
          >

          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'home' })"
          ></simple-navigation-button>

          <v-snackbar
            v-model="$store.state.storeSnackbar.snackbar.active"
            :color="$store.state.storeSnackbar.snackbar.color"
            :timeout="$store.state.storeSnackbar.snackbar.timeout"
            >{{ $store.state.storeSnackbar.snackbar.message }}</v-snackbar
          >
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import ExportOrderInfo from "@/components/orderInfo/ExportOrderInfo";
import DisplayOrderInfo from "@/components/orderInfo/DisplayOrderInfo";
import { G_MODULE_PHOTO_ORDER } from "@/constants";
import { G_MODULE_PHOTO_GIFT } from "@/constants";
import { G_MODULE_ALL } from "@/constants";
import html2pdf from "html2pdf.js";
import printJS from "print-js";
// import firebase from "firebase/app"; // za servertimestamp
import VueCookies from "vue-cookies";
import DialogSendMsg from "@/components/DialogSendMsg";
import DialogBasicYesNo from "@/components/DialogBasicYesNo";

export default {
  name: "homeMenuAdminPackages",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    SimpleNavigationButton,
    ExportOrderInfo,
    DisplayOrderInfo,
    DialogSendMsg,
    DialogBasicYesNo,
  },
  data() {
    return {
      netBackImage: require("@/assets/netBack.png"),
      defaultAppLogo: require("@/assets/defaultAppLogo.png"),
      visibleIsAdminShowPackages: true,
      statusItems: this.$store.state.storeOrders.statusItems,
      dialog: false,
      dialog2: false,
      currentItem: {},
      currentIndex: 0,
      selection: [],
      multipleDelivered: false,
      multipleDone: false,
      dialogAddInternalNote: false,
      dialogDeleteInternalNote: false,
      currentItemInternalNotes: [],
    };
  },
  computed: {
    numOfSelectedItems() {
      let count = 0;
      this.selection.forEach((subject) => {
        if (subject != null) {
          count += 1;
        }
      });
      return count;
    },
  },
  methods: {
    async deleteInternalNote() {
      this.dialogDeleteInternalNote = false;

      this.currentItem.internalNotes.splice(this.currentIndex, 1);

      // zapis v bazo
      if (
        (await this.$store.dispatch("setOrderPackages", this.currentItem)) ==
        "OK"
      ) {
        this.$store.commit({
          type: "showSnackbar",
          color: "success",
          message: this.$t("homeMenuCartInfoRemoveMsgSuccessTitle"),
        });
      } else {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: this.$t("homeMenuCartInfoRemoveMsgErrorTitle"),
        });
      }
    },
    async addInternalNote(msg) {
      this.dialogAddInternalNote = false;

      let currentItemInternalNote = {
        timestamp: new Date(),
        fullName: this.$store.state.storeAuth.userProfile.fullName,
        email: this.$store.state.storeAuth.userProfile.email,
        msg: msg,
      };

      this.currentItemInternalNotes = [];

      if (this.currentItem.internalNotes !== undefined) {
        this.currentItemInternalNotes = this.currentItem.internalNotes;
      }

      this.currentItemInternalNotes.push(currentItemInternalNote);

      // zapis v bazo
      this.currentItem.internalNotes = this.currentItemInternalNotes;
      if (
        (await this.$store.dispatch("setOrderPackages", this.currentItem)) ==
        "OK"
      ) {
        this.$store.commit({
          type: "showSnackbar",
          color: "success",
          message: this.$t("homeMenuCartInfoSendMsgSuccessTitle"),
        });
      } else {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: this.$t("homeMenuCartInfoSendMsgErrorTitle"),
        });
      }
    },
    selectAll() {
      this.selection = [];
      this.$store.state.storeOrders.packages.forEach((x) => {
        this.selection.push(x.id);
      });
    },
    selectDoneOlder() {
      this.selection = [];
      this.$store.state.storeOrders.packages.forEach((x) => {        
        if (x.status == 2) {                                        
          if (this.timePassedSinceAddRaw(x.timestamp.seconds) >= 604000) {
            //console.log(this.timePassedSinceAdd(x.timestamp.seconds))  
            this.selection.push(x.id);      
          }
        }      
      });
    },
    checkMultipleDone(val) {
      if (this.multipleDone) {
        this.multipleDone = false;
        if (val == 0) {
          this.selection.forEach((subject) => {
            if (subject != null) {
              this.sendDoneEmailAndMessage(subject, 2, 0);
              this.checkForGiftCards(subject); // dodamo morebitne nove darilne bone
            }
          });
        } else {
          this.selection.forEach((subject) => {
            if (subject != null) {
              this.sendDoneEmailAndMessage(subject, 2, 1);
              this.checkForGiftCards(subject); // dodamo morebitne nove darilne bone
            }
          });
        }
      } else {
        if (val == 0) {
          this.sendDoneEmailAndMessage(this.currentItem.id, 2, 0);
        } else {
          this.sendDoneEmailAndMessage(this.currentItem.id, 2, 1);
        }
        this.checkForGiftCards(this.currentItem.id); // dodamo morebitne nove darilne bone
      }

      this.selection = [];
    },
    checkMultipleDelivered() {
      if (this.multipleDelivered) {
        this.multipleDelivered = false;
        this.selection.forEach((subject) => {
          if (subject != null) {
            this.sendCompletedRemovePackagesFromStorage(subject, 3, 2);
          }
        });
      } else {
        this.sendCompletedRemovePackagesFromStorage(this.currentItem.id, 3, 2);
      }

      this.selection = [];
    },
    async checkForGiftCards(id) {
      let res = this.$store.state.storeOrders.packages.filter(
        (x) => x.id == id
      );
      if (res.length > 0) {
        res[0].storeCart.cart.forEach(async (y) => {
          if (y.itemGiftCardCode !== undefined) {
            let insert = {
              client: res[0].client,
              itemName: y.itemName,
              fullName: res[0].fullName,
              address1: res[0].address1,
              address2: res[0].address2,
              country: res[0].country,
              email: res[0].email,
              code: y.itemGiftCardCode,
              validTo: y.itemGiftCardValidTo,
              timestamp: res[0].timestamp,
              value: y.itemPrice,
              currency: res[0].currency,
              closed: false,
              notes: "",
              automaticInsert: true,
            };
            // preverimo, ali darilni bon že obstaja
            let checkIfExists = await this.$store.dispatch(
              "checkGiftCardIfExists",
              insert
            );
            // če ne, ga dodamo v bazo
            if (!checkIfExists) {
              let res1 = await this.$store.dispatch("addGiftCard", insert);
              if (res1) {
                this.$store.commit({
                  type: "showSnackbar",
                  color: "success",
                  message: this.$t("giftCardNewAdded"),
                });
              }
            }
          }
        });
      }
    },
    printJSPage(orderId) {
      //console.log(VueCookies.get("orderPrintFontSize"));
      printJS({
        printable: "exportPdf-" + orderId,
        type: "html",
        maxWidth: VueCookies.isKey("orderPrintPageWidth")
          ? VueCookies.get("orderPrintPageWidth")
          : 800,
        font: this.$store.state.storeClient.client.orderPrintSettings.font,
        font_size: VueCookies.isKey("orderPrintFontSize")
          ? String(VueCookies.get("orderPrintFontSize")) + "pt"
          : "12" + "pt",
        honorMarginPadding: true,
        style:
          "@page { size: auto; margin: 5mm } @media print { @page { body { height: auto; } } .lines { padding: 5px 0 5px 0; margin: 5px 0 5px 0; border-bottom: 1px dashed black; border-top: 1px dashed black} .margin1 { margin: 5px 0 5px 0; padding: 0}",
      });
    },
    exportOrderToPdf(orderId) {
      let element = document.getElementById("exportPdf-" + orderId);
      let opt = {
        removeContainer: true,
        filename: orderId + ".pdf",
        image: { type: "jpeg", quality: 0.9 },
        html2canvas: { scale: 2, scrollX: 0, scrollY: 0 },
        jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
      };
      // New Promise-based usage:
      html2pdf().from(element).set(opt).save();
    },
    sendDoneEmailAndMessage(id, status, send) {
      this.setPackageStatus(id, status, send);
      this.dialog = false;
    },
    sendCompletedRemovePackagesFromStorage(id, status, send) {
      this.setPackageStatus(id, status, send);
      this.dialog2 = false;
    },
    async setPackageStatus(id, status, send) {
      try {
        let payload = {
          id: id,
          status: status,
          send: send,
        };

        if (status == 0) {
          Object.assign(payload, {
            status0SetBy: this.$store.state.storeAuth.userProfile.fullName,
            status0Timestamp: new Date(),
          });
        } else if (status == 1) {
          Object.assign(payload, {
            status1SetBy: this.$store.state.storeAuth.userProfile.fullName,
            status1Timestamp: new Date(),
          });
        } else if (status == 2) {
          Object.assign(payload, {
            status2SetBy: this.$store.state.storeAuth.userProfile.fullName,
            status2Timestamp: new Date(),
            hasFiles: false,
          });
        } else if (status == 3) {
          Object.assign(payload, {
            status3SetBy: this.$store.state.storeAuth.userProfile.fullName,
            status3Timestamp: new Date(),
            hasFiles: false,
          });
        }
        const res = await this.$store.dispatch("setOrderPackages", payload);
        if (send == 1 && res == "OK")
          this.$store.commit({
            type: "showSnackbar",
            color: "success",
            message: this.$t("homeMenuCartInfoSendEmailSuccessTitle"),
          });
      } catch (error) {
        this.$store.commit({
          type: "showSnackbar",
          color: "error",
          message: error,
        });
        return;
      }
    },
    getStatusColor(status, light) {
      if (status == 0) {
        if (light) {
          return "background-color: #F8E0E0";
        } else return "error";
      } else if (status == 1) {
        if (light) {
          return "background-color: #F2F5A9";
        } else return "warning";
      } else if (status == 2) {
        if (light) {
          return "background-color: #BCF5A9";
        } else return "success";
      } else {
        if (light) {
          return "background-color: #F2F2F2";
        } else return "black";
      }
    },
    getStatusName(status) {
      if (status == 0) {
        return this.$t("userOrdersStatus0Title");
      } else if (status == 1) {
        return this.$t("userOrdersStatus1Title");
      } else if (status == 2) {
        return this.$t("userOrdersStatus2Title");
      } else {
        return this.$t("userOrdersStatus3Title");
      }
    },
  },
  beforeUpdate() {
    //console.log(">>> BEFORE UPDATE forceUpdate");
    this.$forceUpdate(); // update za dodano pred xx min
  },
  created() {
    this.G_MODULE_PHOTO_ORDER = G_MODULE_PHOTO_ORDER;
    this.G_MODULE_PHOTO_GIFT = G_MODULE_PHOTO_GIFT;
    this.G_MODULE_ALL = G_MODULE_ALL;
    setTimeout(() => (this.visibleIsAdminShowPackages = false), 5000);
  },
  mounted() {
    //console.log(">>> MOUNTED getOrdersInfo dispatch");
    //this.$store.dispatch("getOrdersInfo");
  },
};
</script>
<style>
.v-expansion-panel::before {
  box-shadow: none;
}
.v-expansion-panel-content__wrap {
  padding: 0px;
  margin: 0px;
}
</style>
